import { Outlet } from 'react-router';
import { AccessDenied } from '../../_pages/AccessDenied';
import { useConfigValuesState } from '../../hooks/useConfigValue';

export const ProjectManagerRoute = ({ children }: { children?: React.ReactNode }) => {
    const {
        initialData: {
            aggregatedUser: { user },
        },
    } = useConfigValuesState();

    if (!user.isProjectManager) {
        return <AccessDenied />;
    }

    return children ? <>{children}</> : <Outlet />;
};
